import { Ecom } from 'models/Ecom';
import { useAppSelector } from 'redux/hooks';

type UseEcoms = () => {
    id: number | null;
    fetching: boolean;
    selectedEcom: Ecom | null;
};

const useEcoms: UseEcoms = () => {
    const { fetching, id, selected } = useAppSelector((state) => state.ecoms);

    return {
        id,
        selectedEcom: selected,
        fetching,
    };
};

export default useEcoms;
